import(/* webpackMode: "eager" */ "/vercel/path0/src/app/teams/page.tsx");
